import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

const VideoWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const VideoPanelContainer = styled.section`
  max-height: 810px;
  max-width: 1280px;
  width: 100%;
`;

export interface VideoPanelProps {
  label: string;
  videoFile: {
    url: string;
    fileName: string;
  };
}

export const VideoPanel = (data: VideoPanelProps) => {
  const [isClient, setIsClient] = useState(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    setIsClient(true);
    setPlaying(false);
  }, []);

  if (!isClient) return null;

  return (
    <VideoWrapper>
      <VideoPanelContainer>
        <ReactPlayer
          width="100%"
          height="100%"
          url={data.videoFile?.url}
          playing={playing}
          onPlay={() => setPlaying(true)}
          onPause={() => setPlaying(false)}
          controls
        />
      </VideoPanelContainer>
    </VideoWrapper>
  );
};
